var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name-intro-wrapper"},[_c('h1',{staticClass:"name-intro-title"},[_vm._v("\n    "+_vm._s(_vm.config.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"name-intro-desc"},_vm._l((_vm.config.desc),function(item,index){return _c('p',{key:`name-intro-${index}`},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }